var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"famousSaying"},[_c('div',{staticClass:"famousSayingTitle"},[_c('v-icon',[_vm._v("mdi-alert-circle-outline")]),_vm._v(" "+_vm._s(_vm.sentence)+" ")],1)])}
var staticRenderFns = []

export { render, staticRenderFns }